const Tos = () => {
  return <div>Tos</div>;
};

export default Tos;
